export const fromWidth = minWidth => `(min-width: ${minWidth}px)`;

export const toWidth = maxWidth => `(max-width: ${maxWidth}px)`;

export const betweenWidth = (minWidth, maxWidth) =>
  `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;

export const onlyWidth = (width, nextBreakPoint) =>
  `(min-width: ${width}px) and (max-width: ${nextBreakPoint - 0.02}px)`;
